import { Menu } from "antd";
import { color } from "src/styles/globals";
import styled from "styled-components";
import { Title as SundayTitle } from "sunday-component";

export const ProfileName = styled(SundayTitle).attrs({ level: 6 })`
  text-wrap: balance;
`;

export const CustomMenu = styled(Menu)`
  height: 100%;
  width: 100%;
  .ant-menu-item {
    height: auto;
    margin: 0px !important;
    padding: 16px !important;
    column-gap: 8px;
  }
  .ant-menu-item-selected,
  .ant-menu-item:active {
    color: ${color.carrotOrange} !important;
    background-color: ${color.charcoal03} !important;
  }
  .ant-menu-item:after {
    border-right: unset !important;
  }
`;

export const MainMenuItem = styled(Menu.Item)<{ selected: boolean }>`
  border-top: 1px solid ${color.charcoal03};
  :hover {
    background-color: ${color.charcoal03};
  }
  .ant-menu-title-content .title {
    color: ${(props) =>
      props.selected ? color.carrotOrange : color.charcoal10};
  }
`;

export const Title = styled(SundayTitle).attrs({
  level: 7,
  className: "title",
})``;

export const LogoutTitle = styled(SundayTitle).attrs({ level: 7 })`
  color: ${color.errorRed02};
`;
export const ProfileMenuItem = styled(Menu.Item)<{ columnGap?: string }>`
  pointer-events: none;
  column-gap: ${(props) => props.columnGap || "8px"}!important;
`;
